import { generateMedia } from "styled-media-query";

import { BREAKPOINTS } from "../constants/mediaBreakpoints";

const media = generateMedia(BREAKPOINTS);

export default media;
